module.exports = __webpack_public_path__ + "static/media/feature-more2.74ee72bb.png";